import axios from "axios";
export default axios.create({
  baseURL: "https://dingscreensapi.dingprod.com/",
  headers: {
    "Content-type": "application/json",
  },
});
